import Modal from "../../components/Modal/modal";
import { UpsellSubscriptionModalContent } from "./upsellSubscriptionModalContent";
import { useUpsellSubscriptionContext } from "./upsell-subscription-context";
import PreSubscriptionModal from "./preSubscriptionModal";
import MissOutContentPopup from "./MissOutContentPopup";

const UpsellSubscriptionModal = (props: any) => {
  const { step, isModalOpen, isMaybeLaterOpen } = useUpsellSubscriptionContext();
  return (
    <>
      {step === 0 && isModalOpen ? <PreSubscriptionModal {...props} /> : null}
      {step === 1 ? (
        <Modal
          body={<UpsellSubscriptionModalContent />}
          isOpen={isModalOpen}
          title=""
          isCloseButtonRequired={false}
          modalWidth="w-[99%]"
          modalHeight="max-h-[99%]"
          modalClassNames="overflow-x-hidden overflow-y-auto !px-0 !py-0"
        />
      ) : null}
      <Modal
        body={<MissOutContentPopup {...props} />}
        isOpen={isMaybeLaterOpen}
        title=""
        modalHeight="max-h-[99%]"
        isCloseButtonRequired={false}
        modalClassNames="upsell-modal-popup !pt-0 !pb-0 !px-0 rounded-lg lg:rounded-2xl xs:w-[93%] lg:w-[494px]"
      />
    </>
  );
};

export default UpsellSubscriptionModal;
